 import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NavMenuModule } from './modules/nav-menu/nav-menu.module';

import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { LOCALE_ID } from '@angular/core';

import { AppComponent } from './app.component';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { ValidationServiceProvider } from "./services/validation.service";
import { DateTimeService,AccountService,} from './services';
import { CookieService } from 'ngx-cookie-service';
import { AppRoutingModule } from './app.routing.module';  
import { LoaderModule } from './modules/loader/loader.module';
import { AuthenticationService, AuthGuardService, RoleGuardService, AuthInterceptor } from './services/security';
import { MessageService } from 'primeng/api';
import { DisplayService } from '@services/display.service';
import { AddCsrfHeaderInterceptorService } from './services/security/add-csrf-header-interceptor.service';
import { WithCredentialsInterceptorService } from './services/security/with-credentials-interceptor.service';
import { AppFooterModule } from '@modules/footer/footer.module';
import { AppCommonModule } from '@modules/common/app-common.module';
import { AddAuditDataInterceptorService } from '@services/audit/add-audit-data-interceptor.service';
import { ErrorModule } from '@modules/error/error.module';
import { HomeModule } from './modules/home/home.module'; 
import { AuthAccountModule } from '@modules/account/login/auth.module'; 
import { ShowHidePasswordModule } from 'ngx-show-hide-password';
import { FaIconLibrary,FaConfig, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas, faEllipsisV } from '@fortawesome/free-solid-svg-icons'; 

library.add(fas, faEllipsisV);
registerLocaleData(localeFr, 'fr-FR');

@NgModule({
  imports: [
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    AngularFontAwesomeModule,
    AppCommonModule,
    NavMenuModule,
    AppRoutingModule,
    AuthAccountModule, 
    LoaderModule,
    AppFooterModule,
    ErrorModule,
    HomeModule, 
    ShowHidePasswordModule,
    FontAwesomeModule,
  ],
  declarations: [
    AppComponent
  ],
  providers: [FaConfig,FaIconLibrary,
    ValidationServiceProvider,
    AuthenticationService,
    CookieService,
    AuthGuardService,
    RoleGuardService, 
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    { provide: HTTP_INTERCEPTORS, useClass: AddCsrfHeaderInterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: WithCredentialsInterceptorService, multi: true },
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    { provide: HTTP_INTERCEPTORS, useClass: AddAuditDataInterceptorService, multi: true },
    
    DateTimeService, 
    MessageService,
    DisplayService,
    AccountService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
